<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10zAnUd/tc-custom/9781526743657.jpg?1699746153954" alt="This image is the cover for the book Vehicles & Heavy Weapons of the Vietnam War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vehicles & Heavy Weapons of the Vietnam War
      </h1>
      <p class="bookDescription body article font2">
        <b>This photo-packed reference </b><b>“will be of interest to modelers and military historians alike” (<i>AMPS Indianapolis</i>).</b><br/>  <br/> The ground war in Vietnam pitted a myriad of American tanks, artillery, APC, and trucks against not only the weapons of Communist North Vietnam, but also the terrain. Through archival images, the arsenal of the US Army and USMC are revisited in this informative volume.<br/>  <br/> From the iconic M113 APC to the M48A3 tank, M551 Armored Reconnaissance/Airborne Assault Vehicle, M151 and M54 trucks, M50 Ontos, M107 and M109 artillery, and M42 Duster, the complete array of vehicles fielded is shown. This book, the first in a series on the US military’s weapons, vehicles, aircraft, and naval vessels of the Vietnam War, offers a highly illustrated reference for those wishing to delve deeper into this conflict. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Doyle
      </h2>
      
      <p class="authorDescription body article">An avid military vehicle enthusiast whose collection includes 10 Vietnam-era vehicles, it not surprising that most of his 100+ published books focus on US military vehicles. In June 2015, he was presented the coveted Bart Vanderveen Award by the Military Vehicle Preservation Association, given in recognition of "…the individual who has contributed the most to the historic preservation of military vehicles worldwide."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e92a5f58